import { Dialog, DialogContent } from "@/components/ui/dialog";
import { DealCreateWizard } from "./DealCreateWizard";

interface DealCreateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultPipelineId?: string;
  /** @deprecated Use defaultPipelineId */
  pipelineId?: string;
  defaultStageId?: string;
  defaultPersonId?: string;
  defaultOrganizationId?: string;
  /** Pré-seleciona o owner do novo deal (ex.: MeetingBookedActionDialog). */
  defaultOwnerId?: string;
  /** @deprecated Use defaultPersonId */
  preselectedLeadId?: string;
  /**
   * Called after a deal is successfully created and BEFORE the modal
   * closes itself. Use to chain side-effects that should only run on
   * success (e.g. completing a focus-mode activity), not on cancel.
   */
  onCreated?: (createdDealId: string | undefined) => void;
}

export const DealCreateModal = ({
  open,
  onOpenChange,
  defaultPipelineId,
  pipelineId,
  defaultStageId,
  defaultPersonId,
  defaultOrganizationId,
  defaultOwnerId,
  preselectedLeadId,
  onCreated,
}: DealCreateModalProps) => {
  const effectivePipelineId = defaultPipelineId || pipelineId;
  const effectivePersonId = defaultPersonId || preselectedLeadId;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] flex flex-col p-0 gap-0">
        {open && (
          <DealCreateWizard
            defaultPipelineId={effectivePipelineId}
            defaultStageId={defaultStageId}
            defaultPersonId={effectivePersonId}
            defaultOrganizationId={defaultOrganizationId}
            defaultOwnerId={defaultOwnerId}
            onCreated={onCreated}
            onClose={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
